import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, Carousel, CloseButton, Col, Container, Form, Image, InputGroup, Row, Tab, Tabs } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { rankingBgColor,rankingOpacity} from "./common/RankingUtil";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import UserInfoPopup from './common/UserInfoPopup';
import ImageView from './ImageView';
import ImageViewPopup from './ImageViewPopup';

const TagSelector = (props) => {
    async function getTagList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/tagList/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    const [showViewPopup,setShowViewPopup] = useState(false)
    const [groupId,setGroupId] = useState("")

    // パラメータ
    let param = useParams()

    useEffect(() => {
        if(loginInfo.result){
            /*getFollowUserImage(1).then(json => {
                if(json.result){
                    if(json.data.length > 0){
                        setFollowUserMessage("")
                    } else {
                        setFollowUserMessage("フォローすると最新の投稿を確認できます。")
                    }
                    setFollowUserImage(json.data.splice(0,6))
                }
            })*/
            getTagList().then(r => {
                if(r.result){
                    setTagList(r.data)
                }
            })
        }
    },[loginInfo])

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)

    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }

    const [tagList,setTagList] = useState([])
    const [selected,setSelected] = useState([])

    useEffect(() => {
        props.setSelected(selected)
    },[selected])

    function randomPrompt(){
        setSelected(tagList.flatMap((category,i) => {
            return category.value.filter((tag,j) => j === Math.floor(Math.random() * (category.value.length - 1)))
        }))
    }
    return(
    <>
    <div style={{display:props.show ? "block" : "none",backgroundColor:"#EEEEEE",borderRadius:"5px"}}>
        {showViewPopup ? <ImageViewPopup groupId={groupId} switch={setShowViewPopup} i={Math.random() * 1000000} /> : ""}
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Button className='m-1' variant='outline-primary' onClick={() => randomPrompt()}>ランダム</Button>
        <Button className='m-1' variant='outline-primary' onClick={() => setSelected([])}>全削除</Button>
        <br />
        {selected.map((tag,i) => {
            return <span key={i}>
                <Button className='m-1' variant='secondary' onClick={() => setSelected(selected.filter(t => t.value !== tag.value))}>{tag.label} ×</Button>
            </span>
        })}
        <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
        {tagList.map((category,i) => {
            return <div key={i}>
                <Accordion.Item eventKey={i}>
                    <Accordion.Header>{category.label}</Accordion.Header>
                        <Accordion.Body>
                            {category.value.map((tag,j) => {
                                return <>
                                    <Button className='m-1' key={j} onClick={() => {
                                        if(selected.findIndex((t,k) => t.value === tag.value) === -1){
                                            let newSelected = [].concat(selected)
                                            newSelected.push(tag)
                                            setSelected(newSelected)
                                        } else {
                                            setSelected(selected.filter(t => t.value !== tag.value))
                                        }
                                    }} variant={(selected.findIndex(t => t.value === tag.value) === -1 ? "outline-" : "") + "primary"}>{tag.label}</Button>
                                </>
                            })}
                        </Accordion.Body>
                </Accordion.Item>
            </div>
        })}
        </Accordion>
    </div>
    </>
    )
}

export default TagSelector;
